export const hotKeyWords = [
  {
    url: 'http://souke.xdf.cn/Category/0-154-0-0.html?v=5&amp;amp;adpl=XDF_chuguoN_hotword_1&amp;amp;adct=托福',
    title: '托福'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-186-0-0.html?v=5&amp;amp;adpl=XDF_chuguoN_hotword_2&amp;amp;adct=雅思',
    title: '雅思'
  },
  {
    url: 'http://souke.xdf.cn/Search.aspx?cid=0&amp;kw=GRE&amp;adpl=XDF_chuguoN_hotword_3&amp;adct=GRE',
    title: 'GRE'
  },
  {
    url: 'http://souke.xdf.cn/Search.aspx?cid=0&amp;amp;kw=GMAT&amp;amp;adpl=XDF_chuguoN_hotword_4&amp;amp;adct=GMAT',
    title: 'GMAT'
  },
  {
    url: 'http://souke.xdf.cn/Search.aspx?cid=0&amp;amp;kw=SAT&amp;amp;adpl=XDF_chuguoN_hotword_5&amp;amp;adct=SAT',
    title: 'SAT'
  },
  {
    url: 'http://souke.xdf.cn/Search.aspx?cid=0&amp;amp;amp;kw=%E7%9B%B4%E9%80%9A%E8%BD%A6&amp;amp;adpl=XDF_chuguoN_hotword_6&amp;amp;adct=直通车',
    title: '直通车'
  },
  {
    url: 'http://souke.xdf.cn/Search.aspx?cid=0&amp;amp;amp;kw=%E5%BE%B7%E8%AF%AD&amp;amp;adpl=XDF_chuguoN_hotword_7&amp;amp;adct=德语',
    title: '德语'
  }
]



// WEBPACK FOOTER //
// ./src/api/js/gobroad/hotkeywords.js